import { useState, useEffect } from 'react';
import Modal from './Modal';
import { useAppConfig } from '../context/AppConfigContext';

const messages = {
  en: {
    title: '🎉 Congratulations! 🎉',
    message: '🥳 You are now a VIP user. Enjoy your premium benefits! ✨',
    confirmText: 'Awesome! 🚀',
  },
  ru: {
    title: '🎉 Поздравляем! 🎉',
    message: '🥳 Теперь вы VIP-пользователь. Наслаждайтесь премиум-функциями! ✨',
    confirmText: 'Отлично! 🚀',
  },
  de: {
    title: '🎉 Herzlichen Glückwunsch! 🎉',
    message: '🥳 Du bist jetzt ein VIP-Nutzer. Genieße deine Premium-Vorteile! ✨',
    confirmText: 'Super! 🚀',
  },
};


export default function ShowVip({ language = 'en', onClose }) {
  const { userInfo, updateConfig } = useAppConfig();
  const [isVisible, setIsVisible] = useState(userInfo?.showVip === true);

  const handleClose = () => {
    setIsVisible(false);
    // Сбрасываем showVip в context
    updateConfig({
      userInfo: { ...userInfo, showVip: false },
    });
	if (typeof onClose === "function") {
		onClose();
	}
  };

  if (!isVisible) return null;

  const lang = messages[language] ? language : 'en';
  const { title, message, confirmText } = messages[lang];

  return (
    <Modal
      title={title}
      onClose={handleClose}
      onConfirm={handleClose}
      confirmText={confirmText}
      hideCancel={true}
    >
      <p>{message}</p>
    </Modal>
  );
}
